import React from "react";
import { toastr } from "react-redux-toastr";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { documentsService } from "services";
import { withTranslation } from "react-i18next";

class DocumentRenameModal extends React.Component {
	constructor(props) {
		super(props);
		const { attachment } = props;
		// Extraer el nombre sin extensión
		const fileNameWithoutExtension = this.getFileNameWithoutExtension(attachment.name);
		
		this.nameInputRef = React.createRef();
		this.state = {
			isLoading: false,
			submitted: false,
			fileName: fileNameWithoutExtension,
			errors: {},
			originalExtension: this.getFileExtension(attachment.name)
		};
	}

	componentDidMount() {
		// Hacer focus y seleccionar el texto cuando el modal se monta
		setTimeout(() => {
			if (this.nameInputRef.current) {
				this.nameInputRef.current.focus();
				this.nameInputRef.current.select();
			}
		}, 100);
	}

	getFileNameWithoutExtension = (fileName) => {
		const lastDotIndex = fileName.lastIndexOf('.');
		if (lastDotIndex === -1) {
			return fileName;
		}
		return fileName.substring(0, lastDotIndex);
	};

	getFileExtension = (fileName) => {
		const lastDotIndex = fileName.lastIndexOf('.');
		if (lastDotIndex === -1) {
			return '';
		}
		return fileName.substring(lastDotIndex);
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
			errors: { ...this.state.errors, [name]: null }
		});
	};

	checkValidField = (fieldName) => {
		return this.state.submitted && this.state.errors[fieldName];
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({ submitted: true });

		const { fileName, originalExtension } = this.state;
		const { attachment, currentFolderId, onRenameSuccess, t } = this.props;

		if (!fileName || fileName.trim() === '') {
			this.setState({
				errors: { fileName: t('documents.renameModal.fileNameRequired') }
			});
			return;
		}

		const fullFileName = fileName.trim() + originalExtension;

		this.setState({ isLoading: true });

		documentsService.renameAttachment(currentFolderId, attachment.url, fullFileName)
			.then(response => {
				toastr.success(t('common.success'), t('documents.renameModal.documentRenamed', { name: fullFileName }));
				if (onRenameSuccess) {
					onRenameSuccess();
				}
				this.props.handleClose();
			})
			.catch(error => {
				console.error('Error renaming document:', error);
				toastr.error('Error', t('documents.renameModal.errorRenaming'));
				this.setState({ isLoading: false });
			});
	};

	render() {
		const { attachment, handleClose, t } = this.props;
		const { isLoading, fileName, errors, originalExtension } = this.state;

		return (
			<div>
				<div className="modal-body">
					<p className="intro-text">
						{t('documents.renameModal.changeNameOf', { name: attachment.name })}
					</p>

					<FormGroup className="form-group" controlId="fileName">
						<FormLabel>{t('documents.renameModal.name')} <span className="label-required">*</span></FormLabel>
						<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
							<FormControl
								ref={this.nameInputRef}
								name="fileName"
								onChange={this.handleChange}
								required
								value={fileName}
								isInvalid={this.checkValidField("fileName")}
								type="text"
								placeholder={t('documents.renameModal.fileNamePlaceholder')}
							/>
							<span style={{ fontSize: '14px', color: '#666' }}>
								{originalExtension}
							</span>
						</div>

						<FormControl.Feedback type="invalid">
							{errors.fileName || t('documents.renameModal.fileNameRequired')}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<div className="d-flex justify-content-end gap-2">
						<button
							type="button"
							className="btn btn-secondary"
							onClick={handleClose}
							disabled={isLoading}
						>
							{t('common.cancel')}
						</button>
						<button
							type="button"
							className="btn btn-primary ml-2"
							disabled={isLoading}
							onClick={this.handleSubmit}
						>
							{isLoading ? t('common.saving') : t('common.save')}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(DocumentRenameModal);

